import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { EventEmitter } from "../../event";
import { getPainScaleData, getPatientPainListData } from "../../service/api.service";
import withSnackbar from "../common/hook/useNotification";
import WidgetTree from "../common/widgetTree";

let checkVal = [];
function PainSensitivity(props) {
    let i = 0;
    let location = useLocation();
    const [painData, setPainData] = useState();
    const [patientPainData, setPatientPainData] = useState();
    const [leafNode, setLeafNode] = useState(new Map()); 
    const getPainData = () => {
        getPainScaleData(resp => {
            setPainData(resp);
        })
    }

    const getPatientListData = () => {
        getPatientPainListData(location.state.name, resp => {
            if (resp) {
                if (resp.error) {
                    setPatientPainData({});
                } else {
                    setPatientPainData(resp);
                    calculateOverAllBulletsResult(resp.overallPainLocation)
                }
            } else {
                setPatientPainData({});
            }
        })
    }

    useEffect(() => {
        if (!painData) {
            getPainData();
            getPatientListData()
        }
        if (i < 3 && painData && patientPainData) {
            i++;
            EventEmitter.subscribe("updatePatientPainDataToUpdateListing", ([selectedCodes, forceCheck]) => {
                checkUpdateRequired(selectedCodes);
                if (checkVal.includes(true)) {
                    if (patientPainData.overallPainLocation) {
                        calculateOverAllBulletsResult(patientPainData.overallPainLocation)
                    } else {
                        calculateOverAllBulletsResult([])
                    }
                } else if (forceCheck) {
                    if (patientPainData.overallPainLocation) {
                        calculateOverAllBulletsResult(patientPainData.overallPainLocation)
                    } else {
                        calculateOverAllBulletsResult([])
                    }
                }
            })
        }
        return () => {
            // setPainData()
        }
    })

    EventEmitter.subscribe("updatePatientPainData", (resp) => {
        setTimeout(() => {
            if (resp !== patientPainData) {
                setPatientPainData(resp);
                calculateOverAllBulletsResult(resp.overallPainLocation)
            } else {
                setPatientPainData({});
            }
        }, 500);

    });

    EventEmitter.subscribe("showSnackBarMsg", (msg) => {
        props.snackbarShowMessage(msg);
    })



    const checkUpdateRequired = (selectedFlowLabelsLocal) => {
        checkVal = [];
        if (painData && painData.length) {
            checkUpdateRequired1(selectedFlowLabelsLocal, painData);
        }
        return true;
    }

    const checkUpdateRequired1 = (selectedFlowLabelsLocal, ip) => {
        let val = false
        if (ip && ip.length) {
            ip.forEach(elem => {
                if (selectedFlowLabelsLocal.includes(elem.flowCode)) {
                    if (elem.painType && elem.childPainLocalizations.length > 0) {
                        elem.childPainLocalizations.forEach(innerElem => {
                            if (selectedFlowLabelsLocal.includes(innerElem.flowCode) && !val) {
                                val = true;
                            }
                        })
                    } else
                        checkUpdateRequired1(selectedFlowLabelsLocal, elem.childPainLocalizations)
                }
            })
        }
        checkVal.push(val);
        return val
    }


    const handleCallbackWidget = (ev) => {
        console.log(ev, painData);
    }

    const calculateLeafCode = (child) => {
         child.forEach(element => {
            if (element.childPainLocalizations.length) {
                calculateLeafCode(element.childPainLocalizations)
            } else {
                let leafNodeLocal = leafNode;
                if (leafNodeLocal) {
                    if (element.painType) {
                        const data = { comment: element.comment, pain: element.painType, compare: element.compareString }
                        leafNodeLocal.set(element.flowCode, data);
                        setLeafNode(new Map(leafNodeLocal))
                    }
                    //
                }
            }
        });

        setTimeout(() => {
            if (!leafNode)
                setLeafNode(new Map())
        }, 500);

    }
    const calculateOverAllBulletsResult = (ev) => {
        if (ev?.childPainLocalizations && ev?.childPainLocalizations.length) {
            calculateLeafCode(ev.childPainLocalizations)
        } else {
            setLeafNode(new Map())
        }
    }

    return (
        <div className="animate__animated animate__fadeInDown w-full bg-white relative pt-2">
            <div className=" ">
                {(patientPainData && patientPainData.overallPainLocation) && <div className=" ">
                    {painData && <><WidgetTree
                        key={location.state.name}
                        id={location.state.name}
                        allList={painData}
                        widgetCallback={handleCallbackWidget}
                        patientPainDataAvailbale={true} input={painData}
                        flowCode=""
                        type="root"
                        question="Is there pain in  in the body?"
                    ></WidgetTree></>}

                </div>}
                {(!(patientPainData && patientPainData.overallPainLocation)) && <div className="px-3  ">
                    {painData && <WidgetTree
                        key={location.state.name}
                        id={location.state.name}
                        allList={painData}
                        widgetCallback={handleCallbackWidget}
                        patientPainDataAvailbale={false}
                        input={painData}
                        flowCode=""
                        type="root"
                        question="Is there pain in  in the body?">
                    </WidgetTree>}
                </div>}
            </div>
            {(patientPainData && patientPainData.overallPainLocation) &&
                <div className="w-full align-center center text-center bg-gray-100 justify-center p-4 border border-gray-200 shadow ">
                    <button type="button" className="bg-gray-500  px-5 py-2 rounded text base text-white" onClick={() => props.parentCallbackToTabs(0)}> <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 -mt-1 inline-block mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg> Check Result </button>

                </div>
            }
        </div >
    );

}

export default withSnackbar(PainSensitivity) ;
